import { render } from "./BusInfoModal.vue?vue&type=template&id=2c777eb0&scoped=true"
import script from "./BusInfoModal.vue?vue&type=script&lang=js"
export * from "./BusInfoModal.vue?vue&type=script&lang=js"

import "./BusInfoModal.vue?vue&type=style&index=0&id=2c777eb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c777eb0"

export default script